import axios from 'axios';
import {RENAISSANCE_ADMIN_BASE_URL} from "@renaissancerentals/renaissance-component/lib/service/AdminApi";

export default axios.create({

    baseURL: RENAISSANCE_ADMIN_BASE_URL + "api/"
});